(async () => {
    const { updateURLParams: s, historyPush: n } = await import(window.theme.modules.utils);
    var e = await import(window.theme.modules.baseComponent);
    customElements.define(
        "collection-sort",
        class extends e.default {
            elements = { select: "select" };
            render() {
              if (this.$select != null) {
                this.$select.addEventListener("change", this._onChangeHandler.bind(this));
      		  }
            }
            _onChangeHandler() {
                var { queryURL: e, currentURL: t } = s({ sort_by: this.$select.value }, this.getAttribute("section-id"));
                this.trigger("filterUpadting"), this._fetchChanges(e), n(t);
            }
            _fetchChanges(e) {
                fetch(e)
                    .then((e) => e.text())
                    .then((e) => {
                        this.forwardEvent("sortChange", { html: e });
                  
                  
                           var productCardSwatches = document.querySelectorAll('.prod-card-color-options-item');          
            for (var i = 0; i < productCardSwatches.length; i++) {

              productCardSwatches[i].addEventListener('mouseenter', function(e) {
                var parentElement = e.target.closest('.product-card');
                var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
                var mainImageParent = parentElement.querySelector('.product-card-main-image');
                var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
                var imgAlt = e.target.getAttribute('data-img-alt');
                var imgWidth = e.target.getAttribute('data-img-width');
                var imgHeight = e.target.getAttribute('data-img-height');
                var imgSrc = e.target.getAttribute('data-img-src');
                var imgSrcset = e.target.getAttribute('data-img-srcset');

                if (hoverImage != null) {
                  hoverImage.setAttribute('alt',imgAlt);
                  hoverImage.setAttribute('width',imgWidth);
                  hoverImage.setAttribute('height',imgHeight);
                  hoverImage.setAttribute('src',imgSrc);
                  hoverImage.setAttribute('srcset',imgSrcset);
                }

                if (hoverImageParent != null) {
                  hoverImageParent.classList.add('show');
                }

                if (mainImageParent != null) {
                  mainImageParent.classList.add('hide');
                }
              });

              productCardSwatches[i].addEventListener('mouseleave', function(e) {  
                var parentElement = e.target.closest('.product-card');
                var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
                var mainImageParent = parentElement.querySelector('.product-card-main-image');
                var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
                if (hoverImageParent != null) {
                  hoverImageParent.classList.remove('show');
                }

                if (mainImageParent != null) {
                  mainImageParent.classList.remove('hide');
                }
              });

              productCardSwatches[i].addEventListener('click', function(e) {
                e.preventDefault();

                var parentElement = e.target.closest('.product-card');
                var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
                var mainImageParent = parentElement.querySelector('.product-card-main-image');
                var mainImage = parentElement.querySelector('.product-card-main-image > img');
                var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
                var productCardLink = parentElement.querySelector('.product-card-link');
                var imgAlt = e.target.getAttribute('data-img-alt');
                var imgWidth = e.target.getAttribute('data-img-width');
                var imgHeight = e.target.getAttribute('data-img-height');
                var imgSrc = e.target.getAttribute('data-img-src');
                var imgSrcset = e.target.getAttribute('data-img-srcset');
                var variantLink = e.target.getAttribute('href');

                if (mainImage != null) {
                  mainImage.setAttribute('alt',imgAlt);
                  mainImage.setAttribute('width',imgWidth);
                  mainImage.setAttribute('height',imgHeight);
                  mainImage.setAttribute('src',imgSrc);
                  mainImage.setAttribute('srcset',imgSrcset);
                }

                if (productCardLink != null) {
                  productCardLink.setAttribute('href',variantLink);
                }

                for (var j = 0; j < productCardSwatches.length; j++) {
                  productCardSwatches[j].classList.remove('is-active');
                }

                e.target.classList.add('is-active');
              });
            }

                  
                    });
            }
            _updateURL(e) {
                window.history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
            }
        }
    );
})();
